import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IProperty } from '@shared/models/properties';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectAuthUser } from '@state/auth/auth.selectors';

@UntilDestroy()
@Component({
  selector: 'app-shared-property-list-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
})
export class PropertyListInfoComponent implements OnInit {
  @Input() property?: IProperty;

  protected isLoggedIn = false;
  protected Number = Number;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.isLoggedIn = !!user;
      });
  }
}
